export default __webpack_public_path__ + "65fffd0453217d41146ed787726fbc71.png";